import Vue from "vue";

export const ProductFormEventBus = new Vue();
